import { PolicyFlagsState } from './policyTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: PolicyFlagsState = {
  isUsernameModerationEnabled: false
};

const policyFlagsSlice = createSlice({
  name: 'flags',
  initialState,
  reducers: {
    setUsernameModeration(state, action: PayloadAction<boolean>) {
      state.isUsernameModerationEnabled = action.payload;
    }
  }
});

export const policyFlagsReducer = policyFlagsSlice.reducer;
export const policyFlagsActions = policyFlagsSlice.actions;

export const { setUsernameModeration } = policyFlagsActions;
